module.exports = __webpack_public_path__ + "img/FINAL_TN_PAL_LOGO_WEB.f88bd327.png";